import axios from './axios';

const json = { 'content-type': 'application/json' };

export default {
    getConfiguration() {
        return axios({ method: 'GET', url: 'external-store-sync/configuration', headers: json, preserveFormOnAuthError: true }).then(r => r.data);
    },
    saveConfiguration(data) {
        return axios({ method: 'PUT', url: 'external-store-sync/configuration', headers: json, data, preserveFormOnAuthError: true }).then(r => r.data);
    },
    ping() {
        return axios({ method: 'POST', url: 'external-store-sync/ping', headers: json, preserveFormOnAuthError: true }).then(r => r.data);
    },
    syncProduct(idItem) {
        return axios({ method: 'POST', url: `external-store-sync/products/${encodeURIComponent(idItem)}/sync`, headers: json, preserveFormOnAuthError: true }).then(r => r.data);
    },
    // Sin reintento automático: un corte reenviaría todos los lotes.
    syncAllProducts() {
        return axios({ method: 'POST', url: 'external-store-sync/products/sync', headers: json, preserveFormOnAuthError: true, noAutomaticRetry: true }).then(r => r.data);
    },
    // { running, last }: el panel lo consulta mientras el servidor envía los lotes.
    syncAllProductsStatus() {
        return axios({ method: 'GET', url: 'external-store-sync/products/sync/status', headers: json, preserveFormOnAuthError: true }).then(r => r.data);
    },
};
